import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField
} from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import { Edit } from "@material-ui/icons";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  StyledTableCell,
  StyledTableRow
} from "../../containers/StyledTableCell";
import {
  createSequencing,
  getProjects,
  getProjectSampleAllData,
  getSampleProjectData,
  getSequencing,
  updateSequencing
} from "../../store/actions";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    table: {
      minWidth: 700,
    },
    input: {
      padding: "1px",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
  })
);

interface Props {
  projects: any;
  sampleAllData: any;
  run: any;

  getProjects: any;
  getProjectSampleAllData: any;
  getSampleProjectData: any;
  fetchsamplepdata: any;
  getSequencing: any;
  fetchRunSequencing: any;
  createSequencing: any;
  updateSequencing: any;
}
const RunSequencing: React.FC<Props> = ({
  getProjects,
  projects,
  run,
  getProjectSampleAllData,
  sampleAllData,
  getSampleProjectData,
  createSequencing,
  updateSequencing,
  fetchRunSequencing,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const timer = useRef<any>(0);

  const initialValue = {
    // flowCellType: "none",
    lane: "none",
    project: "",
    projectId: "",
    sample: "",
    sampleName: "",
    sampleId: "",
    library: "",
    type: "",
    libraryId: "",
    averageBase: "",
    dataSizeExpected: "",
    // chemistry: "",
    indexType: "",
    firstIndex: "",
    firstSeq: "",
    secondIndex: "",
    secondSeq: "",
  };
  // For new library value will be -1 while editing value will be library position
  const [libraryPos, setLibraryPos] = useState(-1);
  const [library, setLibrary] = useState(initialValue);
  const [selectedLibrary, setSelectedLibrary] = useState<any>(null);
  const [sample, setSample] = useState<any>(null);
  const [libraries, setLibraries] = useState(run ? run.libraries : []);
  const [displayProject, setDisplayProject] = useState<string>("");
  const [displaySample, setDisplaySample] = useState<string>("");
  const [displayLibrary, setDisplayLibrary] = useState<string>("");
  const [flowCellType, setFlowCellType] = useState<any>(run?.flowCellType);
  const [chemistry, setChemistry] = useState<any>(run?.chemistry);
  // const [page, setPage] = useState(0);
  // const { id } = useParams<{ id: string }>();

  const handleInputChange = (index: any, val: any) => {
    setLibrary({ ...library, [index]: val });
  };

  useEffect(() => {
    setDisplayProject(library?.projectId || "");
    setSample(null);
  }, [library.projectId]);

  useEffect(() => {
    setLibrary({
      ...library,
      sample: sample?._id || "",
      sampleName: sample?.name || "",
      sampleId: sample?.sampleId || "",
    });
    setDisplaySample(sample?.name || "");
    setSelectedLibrary(null);
  }, [sample]);

  useEffect(() => {
    setLibrary({
      ...library,
      library: selectedLibrary?._id || "",
      type: selectedLibrary?.type || "",
      libraryId: selectedLibrary?.libraryId || "",
      // chemistry: selectedLibrary?.chemistry || "",
      indexType: selectedLibrary?.indexType || "",
      firstIndex: selectedLibrary?.firstIndex || "",
      firstSeq: selectedLibrary?.firstSeq || "",
      secondIndex: selectedLibrary?.secondIndex || "",
      secondSeq: selectedLibrary?.secondSeq || "",
    });
  }, [selectedLibrary]);

  useEffect(() => {
    setDisplayLibrary(library?.libraryId || "");
  }, [library.libraryId]);

  // Add data
  const handleAddLibrary = async (e: any) => {
    e.preventDefault();
    const oldLibraries: any = [...libraries];
    if (libraryPos === -1) {
      oldLibraries.push(library);
    } else {
      oldLibraries[libraryPos] = library;
    }
    setLibraries(oldLibraries);
    setLibraryPos(-1);
    setLibrary(initialValue);
  };

  const handleEditLibrary = (data: any, index: any) => {
    setLibrary(data);
    setLibraryPos(index);

  };

  useEffect(() => {
    if (library.project) {
      getSampleProjectData(`?project=${library.project}`);
      getProjectSampleAllData(`?project=${library.project}&qcStatus=Pass`);
    }
  }, [library.project]);

  useEffect(() => {
    if (library?.sample) {
      setSample(sampleAllData?.results?.find((s: any) => s._id === library?.sample));
    }
  }, [sampleAllData]);

  const handleSequencing = async (e: any) => {
    e.preventDefault();
    if (run) {
      await updateSequencing(
        {
          flowCellType: flowCellType,
          chemistry:chemistry,
          libraries: libraries,
        },
        run._id
      );
    } else {
      await createSequencing({
        flowCellType: flowCellType,
          chemistry:chemistry,
          libraries: libraries,
      });
    }
    history.go("/dashboard/gnrelab/Sequencing");
  };
  return (
    <form onSubmit={handleAddLibrary}>
      <Paper style={{ margin: "70px auto", width: "100%", marginTop: 10 }}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="flex-end"
          spacing={2}
          style={{ margin: "1rem auto" }}
        >
          <Grid item xs={12} sm={6}>
            <FormControl style={{ width: "100%" }} className="input">
              <InputLabel>FlowCell Type</InputLabel>
              <Select
                label="FlowCell Type"
                variant="outlined"
                className="input"
                fullWidth
                value={flowCellType || "none"}
                style={{ width: "100%", height: "40px" }}
                required
                onChange={(e) => setFlowCellType(e.target.value)}
              >
                <MenuItem value="none" disabled>
                  Select FlowCell
                </MenuItem>
                <MenuItem value="SP">SP</MenuItem>
                <MenuItem value="S1">S1</MenuItem>
                <MenuItem value="S2">S2</MenuItem>
                <MenuItem value="S4">S4</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl style={{ width: "100%" }} className="input">
              <InputLabel>Chemistry</InputLabel>
              <Select
                label="Chemistry"
                variant="outlined"
                className="input"
                fullWidth
                value={chemistry || "none"}
                style={{ width: "100%", height: "40px" }}
                required
                onChange={(e) => setChemistry(e.target.value)}
              >
                <MenuItem value="none" disabled>Select</MenuItem>
                <MenuItem value="Novaseq">Novaseq</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <div style={{ width: "100%" }}>
          <TableContainer
            className={classes.tableContainer}
            component={Paper}
            style={{ maxHeight: "550px" }}
          >
            <Table stickyHeader aria-label="simple table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="center">Lane ID</StyledTableCell>
                  <StyledTableCell align="center">Project Id</StyledTableCell>
                  <StyledTableCell align="center">Sample Name</StyledTableCell>
                  <StyledTableCell align="center">Lib Id</StyledTableCell>
                  <StyledTableCell align="center">Lib Type</StyledTableCell>
                  <StyledTableCell align="center">Index Type</StyledTableCell>
                  <StyledTableCell align="center">First Index</StyledTableCell>
                  <StyledTableCell align="center">First Seq</StyledTableCell>
                  <StyledTableCell align="center">Second Index</StyledTableCell>
                  <StyledTableCell align="center">Second Seq</StyledTableCell>
                  <StyledTableCell align="center">Average Base</StyledTableCell>
                  <StyledTableCell align="center">Expected Data</StyledTableCell>
                  <StyledTableCell align="center">Edit</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {libraries &&
                  libraries.length > 0 &&
                  libraries?.map((data: any, index: any) => {
                    return (
                      <StyledTableRow key={index}>
                        <StyledTableCell align="center">
                          {data?.lane}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {data?.projectId}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {data?.sampleName}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {data?.libraryId}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {data?.type}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {data?.indexType}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {data?.firstIndex}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {data?.firstSeq}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {data?.secondIndex}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {data?.secondSeq}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {data?.averageBase}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {data?.dataSizeExpected}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <Button color="primary" variant="contained">
                            <Edit
                              onClick={() => handleEditLibrary(data, index)}
                            />
                          </Button>
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="flex-end"
          spacing={2}
          style={{ margin: "1rem auto" }}
        >
          <Grid item xs={12} sm={4} md={2}>
            <FormControl style={{ width: "100%" }} className="input">
              <InputLabel>Lane</InputLabel>
              <Select
                label="Lane ID"
                variant="outlined"
                className="input"
                fullWidth
                value={library.lane}
                style={{ width: "100%", height: "40px" }}
                disabled={chemistry?.length===undefined}
                onChange={(e) => handleInputChange("lane", e.target.value)}
              >
                <MenuItem value="none" disabled>
                  Select Lane{" "}
                </MenuItem>
                <MenuItem value="L1"> Lane 1</MenuItem>
                <MenuItem value="L2"> Lane 2 </MenuItem>
                {flowCellType === "S4" && (
                  <>
                    <MenuItem value="L3 "> Lane 3 </MenuItem>
                    <MenuItem value="L4 "> Lane 4 </MenuItem>
                  </>
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Autocomplete
              id="Project"
              onChange={(event, newValue) => {
                setLibrary({
                  ...library,
                  project: newValue?._id,
                  projectId: newValue?.projectId,
                });
              }}
              options={projects?.results || []}
              blurOnSelect
              getOptionLabel={(option: any) => {
                return (
                  option?.projectId +
                  " " +
                  (option?.institute?.name || "") +
                  " " +
                  (option?.scientist?.name || "") +
                  "," +
                  (option?.dealer?.firmName || "")
                );
              }}
              inputValue={displayProject}
              onInputChange={(event, newInputValue) => {
                let data = newInputValue.split(" ");
                clearTimeout(timer.current);
                timer.current = setTimeout(() => {
                  if(data?.length>0){
                    getProjects(`?search=${data[0]}`);
                  }   
                }, 1000);
                setDisplayProject(newInputValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="input"
                  label="Project"
                  placeholder="Search ID/Client/Dealer Name"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Autocomplete
              id="sample"
              onChange={(event, newValue) => {
                setSample(newValue);
              }}
              options={library.projectId ? (sampleAllData?.results || []) : []}
              blurOnSelect
              getOptionLabel={(option: any) => `${option?.name}`}
              inputValue={displaySample}
              onInputChange={(event, newInputValue) => {
                setDisplaySample(newInputValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="input"
                  label="Sample Names"
                  placeholder="Select Sample Name"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Autocomplete
              id="Lib_Id"
              onChange={(event, newValue) => {
                setSelectedLibrary(newValue);
              }}
              options={sample?.libraries.filter((x: any) => x.status==="Pass") || []}
              blurOnSelect
              disableCloseOnSelect
              aria-required
              getOptionLabel={(option: any) => `${option?.libraryId}`}
              inputValue={displayLibrary}
              onInputChange={(event, newInputValue) => {
                setDisplayLibrary(newInputValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="input"
                  label="Lib Id"
                  placeholder="Select Lib Id"
                  variant="outlined"
                  fullWidth
                  required
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              label="Library Type"
              variant="outlined"
              className="input"
              fullWidth
              disabled
              value={library?.type}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              label="Index Type"
              variant="outlined"
              className="input"
              fullWidth
              value={library?.indexType}
              disabled
              style={{ width: "100%", height: "40px" }}
            />
          </Grid>
          {library?.indexType === "Single Index" ? (
            <>
              <Grid item xs={12} sm={4} md={2}>
                <TextField
                  label="Index ID"
                  variant="outlined"
                  className="input"
                  fullWidth
                  value={library?.firstIndex}
                  disabled
                  style={{ width: "100%", height: "40px" }}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={2}>
                <TextField
                  label="Index Seq"
                  variant="outlined"
                  className="input"
                  fullWidth
                  value={library?.firstSeq}
                  style={{ width: "100%", height: "40px" }}
                  disabled
                />
              </Grid>
            </>
          ) : (
            ""
          )}
          {library?.indexType === "Dual Index" ? (
            <>
              <Grid item xs={12} sm={4} md={2}>
                <TextField
                  label="Index ID"
                  variant="outlined"
                  className="input"
                  fullWidth
                  value={library?.firstIndex}
                  disabled
                  style={{ width: "100%", height: "40px" }}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={2}>
                <TextField
                  label="Index Seq"
                  variant="outlined"
                  className="input"
                  fullWidth
                  value={library?.firstSeq}
                  style={{ width: "100%", height: "40px" }}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={4} md={2}>
                <TextField
                  label="Index 2"
                  variant="outlined"
                  className="input"
                  fullWidth
                  value={library?.secondIndex}
                  disabled
                  style={{ width: "100%", height: "40px" }}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={2}>
                <TextField
                  label="Index Seq 2"
                  variant="outlined"
                  className="input"
                  fullWidth
                  value={library?.secondSeq}
                  style={{ width: "100%", height: "40px" }}
                  disabled
                />
              </Grid>
            </>
          ) : (
            ""
          )}
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              label="Average Size"
              variant="outlined"
              className="input"
              fullWidth
              required
              value={library?.averageBase}
              onChange={(e) => handleInputChange("averageBase", e.target.value.replace(/\s/g,''))}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              label="Expected Data(GB)"
              variant="outlined"
              className="input"
              fullWidth
              required
              value={library?.dataSizeExpected}
              onChange={(e) =>
                handleInputChange("dataSizeExpected", e.target.value.replace(/\s/g,''))
              }
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Button
              color="primary"
              variant="contained"
              type="submit"
              style={{ width: 200, height: 46, marginTop: -5 }}
            >
              {libraryPos !== -1 ? 'Update' : 'Add'}
            </Button>
          </Grid>
          <Grid item xs={12} sm={4} md={2}></Grid>
          <Grid item xs={12} sm={4} md={2}></Grid>
          <Grid item xs={12} sm={4} md={2}></Grid>
        </Grid>
      </Paper>
      <Grid item xs={12} style={{ textAlign: "end" }}>
        <Button
          color="secondary"
          variant="contained"
          style={{ width: 200, height: 46, marginTop: -60 }}
          onClick={handleSequencing}
        >
          Submit
        </Button>
      </Grid>
    </form>
  );
};
const mapStateToProps = (state: any) => ({
  projects: state.GenomicsLabReducer.projects,
  sampleAllData: state.GenomicsLabReducer.sampleAllData,
  fetchsamplepdata: state.GenomicsLabReducer.fetchsamplepdata,
  fetchRunSequencing: state.GenomicsLabReducer.fetchRunSequencing,
});
export default connect(mapStateToProps, {
  getProjects,
  getProjectSampleAllData,
  getSampleProjectData,
  getSequencing,
  createSequencing,
  updateSequencing,
})(RunSequencing);
